// trackingApiUrlMap is not exported from @qubictron/url — Parcel search API disabled for now.
// import { trackingApiUrlMap } from "@qubictron/url";
import axios from "axios";
import { ParcelQueryParams } from "./query.types";
import { ParcelResponseDTO } from "./response.types";
import { injectAuthHeader, injectDataInterceptor } from "shared/api/utils/api.utils";

// const TRACKING_URL = trackingApiUrlMap
//   .prod()
//   .setPathname("parcel")
//   .handleQueryParams((qp) => {
//     qp.set("api_key", "1");
//     qp.set("path", "true");
//   })
//   .build();
const TRACKING_URL = "";

const requestInstance = axios.create();
requestInstance.defaults.baseURL = TRACKING_URL;
injectDataInterceptor(requestInstance);
injectAuthHeader(requestInstance);

class ParcelSearchService {
  public search(params: ParcelQueryParams, signal?: AbortSignal): Promise<ParcelResponseDTO> {
    return requestInstance.get("", {
      params,
      ...(signal ? { signal } : {}),
    });
  }
}

export const parcelSearchService = new ParcelSearchService();
